export default {
  cn: [
    {
      version: '2.0.0',
      time: '2019.09.07',
      changes: [
        '使用 <strong>render</strong> 函数的方式完全重构插件',
        '增加 <strong>max-length</strong> 参数，指定建议项目最多可显示的数量',
        '增加列表项目支持使用作用域插槽（scpoed slot）进行自定义显示',
        '使用 <strong>Javascript Standard</strong> 语法标准对项目进行格式化',
        '升级 <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a> 升级至 v2.1.1 版本'
      ]
    }, {
      version: '1.1.3',
      time: '2018.12.23',
      changes: [
        '增加 <strong>placeholder</strong> 参数，用于指定未输入内容内背景提示的文本内容',
        '增加 <strong>disabled</strong> 参数，用于设置插件为禁用状态',
        '下拉菜单容器使用插件 <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a>',
        '增加 <strong>values</strong> 事件，响应列表项目选中并输出项目原始数据',
        '修复 webpack.config.js 中项目组件名称命名不正确的问题'
      ]
    }, {
      version: '1.0',
      time: '2018.07.05',
      changes: [
        '开发并发布基于 <strong>Vue2</strong> 的 <code>v-suggest</code> 插件'
      ]
    }
  ],

  en: [
    {
      version: '2.0.0',
      time: '2019.09.07',
      changes: [
        'Use <strong>render functions</strong> to completely refactored plugin',
        'Add <strong>max-length</strong> prop, limit the number of suggestion results list',
        'Add scoped slot supports, make customize suggestions more flexible',
        'Use <strong>Javascript Standard</strong> Style to format code',
        'Upgrade <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a> plugin to v2.1.1'
      ]
    }, {
      version: '1.1.3',
      time: '2018.12.23',
      changes: [
        'add <strong>placeholder</strong> option, set the short hint is displayed when no content is entered',
        'add <strong>disabled</strong> option, used to set disabled state of the plugin',
        'the drop down container layer change to plugin <a href="https://github.com/TerryZ/v-dropdown" target="_blank">v-dropdown</a>',
        'add <strong>values</strong> event, used to respond suggestion list item select and output raw data',
        'fixed the plugin name incorrect in webpack.config.js'
      ]
    }, {
      version: '1.0',
      time: '2018.07.05',
      changes: [
        'develop and publish <code>v-suggest</code> plugin for <strong>Vue2</strong>'
      ]
    }
  ]
}
